/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetNutrientConfigQueryResponse, ArtifactsControllerGetNutrientConfigPathParams, ArtifactsControllerGetNutrientConfig400, ArtifactsControllerGetNutrientConfig404 } from "../../models/documentArtifactsController/ArtifactsControllerGetNutrientConfig";

function getArtifactsControllerGetNutrientConfigUrl(documentId: ArtifactsControllerGetNutrientConfigPathParams["documentId"], renditionId: ArtifactsControllerGetNutrientConfigPathParams["renditionId"], artifactId: ArtifactsControllerGetNutrientConfigPathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/artifacts/${artifactId}/nutrient-config` as const }  
  return res
}

/**
 * @description Uploads the artifact PDF to Nutrient Document Engine if needed, then returns a JWT and server URL for server-based viewing.
 * @summary Get Nutrient Document Engine config for an artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/nutrient-config}
 */
export async function artifactsControllerGetNutrientConfig(documentId: ArtifactsControllerGetNutrientConfigPathParams["documentId"], renditionId: ArtifactsControllerGetNutrientConfigPathParams["renditionId"], artifactId: ArtifactsControllerGetNutrientConfigPathParams["artifactId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<ArtifactsControllerGetNutrientConfig400 | ArtifactsControllerGetNutrientConfig404>, unknown>({ method : "GET", url : getArtifactsControllerGetNutrientConfigUrl(documentId, renditionId, artifactId).url.toString(), ... requestConfig })  
  return res.data
}